<template>
  <div class="personal-informations-modal">
    <v-dialog
      v-model="isVisible"
      max-width="780"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title
          class="personal-informations-modal__title headline"
          primary-title
        >
          PRIMARY INFORMATIONS
          <v-btn icon large color="primary" @click="closeModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pb-0">
          <v-form ref="personalInformationForm" v-model="isFormValid" @submit.prevent="submitForm">
            <v-row class="personal-informations-modal__row">
              <v-col class="personal-informations-modal__col">
                <v-text-field
                  v-model="personal_data.first_name"
                  class="form-field"
                  :rules="[rules.required]"
                  dense
                  label="First name*"
                  placeholder="Type name"
                />
              </v-col>
              <v-col class="personal-informations-modal__col">
                <v-text-field
                  v-model="personal_data.last_name"
                  class="form-field"
                  :rules="[rules.required]"
                  dense
                  label="Last name*"
                  placeholder="Type name"
                />
              </v-col>
              <v-col class="personal-informations-modal__col">
                <v-text-field
                  v-model="personal_data.email"
                  class="form-field"
                  :rules="[rules.required]"
                  dense
                  label="Email Address*"
                  placeholder="Enter your e-mail address"
                />
              </v-col>
            </v-row>

            <v-row class="personal-informations-modal__row">
              <v-col class="personal-informations-modal__col">
                <v-menu
                  ref="birthdatePicker"
                  content-class="datepicker-menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <div class="form-field--date-wrapper" v-on="on">
                      <v-text-field
                        :value="personal_data.birthdate | displayDate"
                        class="form-field"
                        dense
                        label="Birthday"
                        placeholder="Chose date"
                        readonly
                        v-on="on"
                      >
                        <template #append>
                          <v-icon color="blue">
                            mdi-calendar
                          </v-icon>
                        </template>
                      </v-text-field>
                    </div>
                  </template>
                  <v-date-picker
                    v-model="personal_data.birthdate"
                    no-title
                    scrollable
                    @input="$refs.birthdatePicker.save(true)"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col class="personal-informations-modal__col">
                <v-text-field
                  v-model="personal_data.city"
                  class="form-field"
                  :rules="[rules.required]"
                  dense
                  label="City*"
                  placeholder="Type your city"
                />
              </v-col>
              <v-col class="personal-informations-modal__col">
                <v-autocomplete
                  v-model="personal_data.nationality"
                  class="form-field"
                  :items="nationalities"
                  item-value="nationality"
                  item-text="nationality"
                  :rules="[rules.required]"
                  dense
                  label="Nationality*"
                  item-color="blue"
                  placeholder="Choose nationality"
                />
              </v-col>
            </v-row>

            <v-row class="personal-informations-modal__row">
              <v-col class="personal-informations-modal__col">
                <v-text-field
                  v-model="personal_data.phone_number"
                  class="form-field"
                  dense
                  label="Phone number"
                  placeholder="Type phone number"
                />
              </v-col>
              <v-col class="personal-informations-modal__col">
                <v-select
                  v-model="personal_data.level"
                  class="form-field"
                  :items="featuresData.level"
                  dense
                  item-color="blue"
                  :rules="[rules.required]"
                  label="Level*"
                  placeholder="Select your level"
                />
              </v-col>
              <v-col class="personal-informations-modal__col">
                <v-text-field
                  v-model="personal_data.experience_in_years"
                  class="form-field"
                  dense
                  :rules="[rules.required, rules.negative]"
                  label="Experience*"
                  placeholder="Type your experience in years"
                  type="number"
                  min="0"
                />
              </v-col>
            </v-row>

            <v-row class="personal-informations-modal__row">
              <v-col class="personal-informations-modal__col">
                <v-text-field
                  v-model="personal_data.linkedin_link"
                  class="form-field"
                  dense
                  label="Linkedin"
                  placeholder="Paste your link"
                />
              </v-col>
              <v-col class="personal-informations-modal__col">
                <v-text-field
                  v-model="personal_data.git_link"
                  class="form-field"
                  dense
                  label="Git"
                  placeholder="Paste your link"
                />
              </v-col>
              <v-col class="personal-informations-modal__col">
                <v-text-field
                  v-model="personal_data.skype_link"
                  class="form-field"
                  dense
                  label="Skype"
                  placeholder="Paste your link"
                />
              </v-col>
            </v-row>

            <v-row class="personal-informations-modal__row">
              <v-col class="personal-informations-modal__col col-4">
                <v-select
                  v-model="personal_data.verification_status"
                  class="form-field"
                  :items="featuresData.verification_status"
                  dense
                  item-color="blue"
                  label="Verification status"
                  placeholder="Select your status"
                />
              </v-col>
              <v-col class="personal-informations-modal__col col-4">
                <v-select
                  v-model="personal_data.technical_verification_status"
                  class="form-field"
                  :items="featuresData.verification_status"
                  dense
                  item-color="blue"
                  label="Technical verification status"
                  placeholder="Select your status"
                />
              </v-col>
              <v-col class="personal-informations-modal__col col-4">
                <v-select
                  v-model="personal_data.status"
                  class="form-field"
                  :items="featuresData.status"
                  :rules="[rules.required]"
                  dense
                  item-color="blue"
                  label="Status*"
                  placeholder="Select your status"
                />
              </v-col>
            </v-row>

            <div v-if="personal_data.status === 'Software house'"
              class="personal-informations-modal__software-house">
              <span class="pl-4 font-weight-bold">PM INFORMATION</span>
              <v-row class="personal-informations-modal__row">
                <v-col class="personal-informations-modal__col">
                  <v-text-field
                    v-model="personal_data.software_house.name"
                    class="form-field"
                    :items="featuresData.status"
                    dense
                    label="Software House"
                    placeholder="Enter your SH name"
                  />
                </v-col>
                <v-col class="personal-informations-modal__col">
                  <v-text-field
                    v-model="personal_data.software_house.pm_first_name"
                    class="form-field"
                    dense
                    label="First name"
                    placeholder="Paste your link"
                  />
                </v-col>
                <v-col class="personal-informations-modal__col">
                  <v-text-field
                    v-model="personal_data.software_house.pm_last_name"
                    class="form-field"
                    dense
                    label="Last name"
                    placeholder="Paste your link"
                  />
                </v-col>
              </v-row>

              <v-row class="personal-informations-modal__row">
                <v-col class="personal-informations-modal__col col-4">
                  <v-text-field
                    v-model="personal_data.software_house.pm_email"
                    class="form-field"
                    :items="featuresData.status"
                    :rules="[rules.required]"
                    dense
                    label="Email*"
                    placeholder="Enter your PM's email"
                  />
                </v-col>
                <v-col class="personal-informations-modal__col col-4">
                  <v-text-field
                    v-model="personal_data.software_house.pm_phone_number"
                    class="form-field"
                    :rules="[rules.required]"
                    dense
                    label="Phone number*"
                    placeholder="Enter your PM's phone number"
                  />
                </v-col>
              </v-row>
            </div>
          </v-form>
        </v-card-text>

        <v-card-actions class="personal-informations-modal__actions">
          <v-btn
            class="white--text fw-400"
            color="blue"
            large
            min-width="234"
            :loading="isSubmitProcessing"
            @click="submit"
          >
            SAVE CHANGES
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import validationRules from '@/helpers/validators';
import nationalities from '@/helpers/nationalities';

const rules = validationRules;

export default {
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      rules,
      isFormValid: true,
      nationalities,
      personal_data: {
        id: '',
        first_name: '',
        last_name: '',
        email: '',
        city: '',
        nationality: '',
        phone_number: '',
        birthdate: '',
        level: '',
        experience_in_years: '',
        is_verified: false,
        linkedin: '',
        git: '',
        skype: '',
        status: '',
        software_house: {
          name: '',
          pm_first_name: '',
          pm_last_name: '',
          pm_email: '',
          pm_phone_number: '',
        },
      },
    };
  },

  computed: {
    ...mapState('hrDeveloper', [
      'developer',
      'isSubmitProcessing',
    ]),

    ...mapState('features', [
      'featuresData',
    ]),

    isVisible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },

  watch: {
    isVisible() {
      this.personal_data = this.isVisible ? { ...this.developer.personal_data } : {};
    },
  },

  methods: {
    ...mapActions('hrDeveloper', [
      'updateDeveloper',
    ]),

    closeModal() {
      this.$emit('input', false);
    },

    submit() {
      this.$refs.personalInformationForm.validate();

      if (this.isFormValid) {
        const developer = {};
        developer.personal_data = this.personal_data;

        this.updateDeveloper(developer)
          .then(() => {
            this.closeModal();
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.personal-informations-modal {
  &__title {
    display: flex;
    justify-content: space-between;
    font-weight: 600 !important;
    font-size: 22px !important;
  }

  &__actions {
    padding: 0 24px 16px 24px;
    justify-content: flex-end;
  }

  &__row {
    margin-right: -8px;
    margin-left: -8px;
  }
  &__col {
    padding: 0 8px 12px;
  }

  &__subtitle {
    color: $color--primary;
    font-size: 18px;
    line-height: 21px;
    font-weight: 400;
    margin-bottom: 8px;
  }

  &__input {
    max-width: 220px;
  }
}
</style>
